<template>
    <div class="head-container" :style="{backgroundColor: backgroundColor}">
        <div class="l-content">
            <el-button @click="handleMenu" icon="el-icon-menu" size="mini"></el-button>
            <span class="text">首页</span>
        </div>
        <div class="r-content">
            <el-dropdown @command="handleClick">
                <span class="el-dropdown-link">
                    <img class="user" src="../assets/images/user.png" alt="">
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item>个人中心</el-dropdown-item>
                    <el-dropdown-item command="logout">退出</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
    </div>
</template>

<script>
import Cookie from 'js-cookie'
export default {
    data() {
        return {
            backgroundColor: process.env.VUE_APP_HEADER_COLOR
        };
    },
    methods:{
        handleMenu() {
            this.$store.commit('collapseMenu');
        },
        handleClick(command) {
            if(command === 'logout') {
                Cookie.remove('token');
                this.$router.push('/login')
            }
        }
    }
}
</script>

<style lang="less" scoped>
.head-container {
    padding: 0 20px;
    background-color: #333;
    height: 60px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .text {
        color: #fff;
        font-size: 14px;
        margin-left: 10px;
    }
    .r-content {
        .user {
            width: 40px;
            height: 40px;
            border-radius: 50%;
        }
    }
}
</style>